export function searchCompany() {
  document.querySelectorAll('form input[name="billing_company"], .gform_wrapper input[data-dataset="company_search"]').forEach((input) => {
    const wrapper = initSearchElements();
    input.parentNode.classList.add('autocomplete-input-wrapper');
    //input.setAttribute('autocomplete', 'off');
    input.setAttribute('placeholder', 'Søk etter firma...');
    input.parentNode.insertBefore(wrapper, input.nextSibling);

    input.addEventListener('input', debounce(function() {
      const query = this.value;
      if(!query) {
        wrapper.dataset.wrapperActive = 'false';
        return;
      }
      
      searchEntities(query)
        .then(results => {
          const list = wrapper.querySelector('.autocomplete-list');
          list.innerHTML = ''; // Clear previous results
          if (results && results.length > 0) {
            results.forEach(entity => {
              const item = document.createElement('div');
              item.className = 'autocomplete-list-item';
              item.textContent = `${entity.name} (${entity.orgnr})`;
              item.dataset.orgnr = entity.orgnr;
              item.dataset.name = entity.name;
              item.addEventListener('click', () => {
                input.value = `${entity.name} (${entity.orgnr})`;
                input.dispatchEvent(new Event('change'));
                input.dataset.name = entity.name;
                input.dataset.orgnr = entity.orgnr;
                setHiddenInput(input, entity.name, entity.orgnr);
                wrapper.dataset.wrapperActive = 'false';
                list.innerHTML = ''; // Clear previous results
              });
              list.appendChild(item);
            });
            wrapper.dataset.wrapperActive = 'true';

          } else {
            console.warn('No results found for the search term.');
          }
        })
        .catch(error => {
          console.error('Error fetching entities:', error);
        });
    }, 300));

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target) && !input.contains(event.target)) {
        wrapper.dataset.wrapperActive = 'false';
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        wrapper.dataset.wrapperActive = 'false';
      }
    });
  });
}


function initSearchElements() {
  const wrapper = document.createElement('div');
  wrapper.className = 'autocomplete_result_wrapper';
  wrapper.dataset.wrapperActive = 'false';

  const elementsFound = document.createElement('div');
  elementsFound.className = 'autocomplete-list';
  wrapper.appendChild(elementsFound);
  return wrapper;
}

function setHiddenInput(input, name, orgnr) {
  const closestForm = input.closest('form');
  if(!closestForm) return;

  // WooCommerce
  if(closestForm.querySelector('input[name="billing_company_name"]') && closestForm.querySelector('input[name="billing_company_orgnr"]')) {
    const company_name = closestForm.querySelector('input[name="billing_company_name"]');
    const company_orgnr = closestForm.querySelector('input[name="billing_company_orgnr"]');
    company_name.value = name;
    company_name.dispatchEvent(new Event('change'));
    company_orgnr.value = orgnr;
    company_orgnr.dispatchEvent(new Event('change'));
    return;
  }

  // Gravity Forms
  const companyNameField = closestForm.querySelector('input[data-dataset="company_name"]');
  const companyOrgnrField = closestForm.querySelector('input[data-dataset="company_orgnr"]');
  if(companyNameField && companyOrgnrField) {
    companyNameField.value = name;
    companyNameField.dispatchEvent(new Event('change'));
    companyOrgnrField.value = orgnr;
    companyOrgnrField.dispatchEvent(new Event('change'));
    return;
  }
}

function searchEntities(search) {
  let searchBy = 'navn';
  if(search.length === 9 && /^\d+$/.test(search)) {
    searchBy = 'organisasjonsnummer';
  }
  return fetch(`https://data.brreg.no/enhetsregisteret/api/enheter?${searchBy}=${search}&konkurs=false&underAvvikling=false&underTvangsavviklingEllerTvangsopplosning=false&size=10`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (!data || !Array.isArray(data?._embedded?.enheter)) {
        throw new Error('Invalid data format received from Brønnøysundregistrene');
      }
      const results = data?._embedded?.enheter?.map(entity => ({
        name: entity.navn,
        orgnr: entity.organisasjonsnummer,
      }));
      return results;
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
}

function debounce(func, delay) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}